// src/api.js
const BASE =
  (process.env.REACT_APP_API_BASE || `${window.location.origin}/api`).replace(/\/$/, "");

// Get auth token from localStorage
function getAuthToken() {
  return localStorage.getItem('token');
}

// Get auth headers
function getAuthHeaders() {
  const token = getAuthToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
}

// --- tiny helpers ---
async function getJSON(path, additionalHeaders = {}) {
  const res = await fetch(`${BASE}${path}`, { 
    headers: { ...getAuthHeaders(), ...additionalHeaders }
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}

async function postJSON(path, body, additionalHeaders = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method: "POST",
    headers: { ...getAuthHeaders(), ...additionalHeaders },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`POST ${path} -> ${res.status} ${res.statusText} ${text}`);
  }
  return res.json();
}

// --- public API used by the app ---
export function apiBase() {
  return BASE;
}

export function fetchHealth() {
  return getJSON(`/health`);
}

export function fetchVersion() {
  return getJSON(`/version`);
}

export function fetchReports() {
  return getJSON(`/reports`);
}

// MRV Samples - now with JWT auth
export function createMRVSample({ email, data }) {
  const headers = {};
  if (email) headers["X-User-Email"] = email;
  const qs = email ? `?email=${encodeURIComponent(email)}` : "";
  return postJSON(`/mrv_samples${qs}`, data, headers);
}

export function listMRVSamples({ email }) {
  const qs = email ? `?email=${encodeURIComponent(email)}` : "";
  return getJSON(`/mrv_samples${qs}`);
}

export function csvURLForMRV({ email }) {
  const qs = email ? `?email=${encodeURIComponent(email)}` : "";
  return `${BASE}/mrv_samples.csv${qs}`;
}

// Generic API fetch function with auth
export async function apiFetch(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    headers: {
      ...getAuthHeaders(),
      ...options.headers,
    },
  });
  
  if (!response.ok) {
    throw new Error(`API Error: ${response.statusText}`);
  }
  
  return response.json();
}